<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img7-1" src="images/img7-1.jpg"/></p>
<p class="caption">At 8.30 pm, 2 April 1917, President Wilson appeared before Congress, sitting in joint session, and read his message recommending that a state of war be declared to exist between the United States and the Imperial German Government. The war resolution was passed by the Senate 4 April and by the House 6 April 1917. It was signed by the President and became effective the same day.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01b-a_AMERICAN_EXPEDITIONARY_FORCE.vue?32546960